export const isServer = false
export const loadServerRoute: never = undefined as never
